module.exports = __webpack_public_path__ + "static/media/dumpster-pw.e48d17bd.png";